import { FC } from 'react'
import { Tabs, TabsProps } from 'antd'
import { SuiteName } from '@signifyd/cypress'
import { useDashboardParams } from 'core/queryParams/useDashboardParams'
import { getSuiteLabel } from 'core/queryParams/suiteParam'
import { DashboardItem } from './DashboardItem'

const SUITES: readonly SuiteName[] = ['fe', 'qe']

const Dashboard: FC = () => {
  const {
    query: { suite },
    setQuery,
  } = useDashboardParams()

  const items: TabsProps['items'] = SUITES.map((suiteName) => ({
    key: suiteName,
    label: `${getSuiteLabel(suiteName)} tests`,
    children: <DashboardItem suite={suiteName} />,
  }))

  return (
    <Tabs
      activeKey={suite}
      items={items}
      onChange={(key) => setQuery({ suite: key as SuiteName })}
    />
  )
}

export default Dashboard
